import "./FrequentlyAskedQuestions.module.css";
import Header from "@/reusable_sections/Header";
import FaqAccordion from "./sections/FaqAccordion";
import Footer from "@/reusable_sections/Footer";
export default function FrequentlyAskedQuestionsPage() {
  return <div>
      <Header />
      <FaqAccordion />
      <Footer />
    </div>;
}